import React from "react";

// Circular Teer Aachary target + arrows logo (inline SVG so it scales crisply)
export default function Logo({ size = 44, showRing = true }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Night Teer logo"
      className="shrink-0"
    >
      {showRing && (
        <circle cx="50" cy="50" r="48" fill="#F3F6F8" stroke="#0D1B2A" strokeWidth="2" />
      )}
      <circle cx="50" cy="50" r="36" fill="#F7DBDB" stroke="#0D1B2A" strokeWidth="1.5" />
      <circle cx="50" cy="50" r="26" fill="#F6C1C1" stroke="#0D1B2A" strokeWidth="1.2" />
      <circle cx="50" cy="50" r="17" fill="#EF5350" stroke="#0D1B2A" strokeWidth="1" />
      <circle cx="50" cy="50" r="9" fill="#FFEB3B" stroke="#0D1B2A" strokeWidth="1" />
      <circle cx="50" cy="50" r="3.5" fill="#0D1B2A" />
      {/* Arrows */}
      <g stroke="#0D1B2A" strokeWidth="1.6" strokeLinecap="round">
        <line x1="8" y1="14" x2="50" y2="50" />
        <line x1="4" y1="46" x2="50" y2="50" />
        <line x1="10" y1="82" x2="50" y2="50" />
      </g>
      <g fill="#D62828" stroke="#0D1B2A" strokeWidth="0.6">
        <polygon points="4,10 12,6 15,17 8,20" />
        <polygon points="1,43 8,39 11,50 3,53" />
        <polygon points="5,79 13,75 16,86 8,89" />
      </g>
    </svg>
  );
}
